// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BannerSection_wrapper__2qum7","banner-container":"BannerSection_banner-container__3w9bH","banner-image":"BannerSection_banner-image__1hlQY"};